import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_APPSEBRAE}${process.env.VUE_APP_API_PATH}/appsebrae/gestores/consultorias`

export default {
    obterTodasConsultorias() {
        return axiosJwt
            .get(`${api}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriaPorId(consultoriaId) {
        return axiosJwt
            .get(`${api}/${consultoriaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarConsultoria(consultoria) {
        return axiosJwt
            .post(`${api}/aprovarreprovar`, consultoria)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConsultoriaAnexo(consultoriaAnexoId) {
        return axiosJwt
            .get(`${api}/anexos/${consultoriaAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAvaliacao(consultoriaId) {
        return axiosJwt
            .get(`${api}/${consultoriaId}/avaliacao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
